import { render, staticRenderFns } from "./Erratum.vue?vue&type=template&id=18ec64cb&"
import script from "./Erratum.vue?vue&type=script&lang=ts&"
export * from "./Erratum.vue?vue&type=script&lang=ts&"
import style0 from "./Erratum.vue?vue&type=style&index=0&id=18ec64cb&prod&module=true&lang=stylus&"
import style1 from "./Erratum.vue?vue&type=style&index=1&id=18ec64cb&prod&lang=stylus&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports